
$('.shopify-section--image-with-text-block').appendTo('.slider-banner-top');
$('.shopify-section--image-with-text-block').wrap('<div class="single-slide-wrapper"></div>');
$(".slider-banner-top").slick({
      dots: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:false,
      speed: 1000,
    autoplay: true,
    autoplaySpeed: 5000,
   pauseOnHover: false,
      pauseOnFocus: false,
  });

if (navigator.userAgent.indexOf('Mac OS X') != -1) {
  $("body").addClass("mac-os");
} else {
  $("body").addClass("window-os");
}
$(window).on("resize",function() {   
   if($('iframe#preview-bar-iframe').css('display') == 'none'){
    setTimeout(function(){ $('html').css('padding-bottom','0px'); }, 1000);
   }  
});
  $(document).ready(function(){

   // Set up a timeout loop to continuously check for the "Add to Cart" button
    const interval = setInterval(function () {
       
      //  const addToCartButton =  $("#AddToCart").attr('value');       
      $(".product-form__add-button").each(function(){
           if($(this).data('preorder') == 'preorder'){
              if ($(this).next('.preorder-description').length > 0) {           
                  $(".product-form__add-button").addClass('show');
                $(".dyn_theme_ext").addClass('show'); // Show the PRE ORDER button
                  clearInterval(interval); // Clear the interval once the button is removed       
              }
           }
        });
      
    }, 100); // Check every 100 milliseconds
    
    
//   if($('.us_ca_banner_section').length > 0){  
//   setTimeout(() => {
//   document.querySelectorAll('.us_ca_banner_section .image-with-text-block__content .h3 split-lines').forEach((heading) => {
//   const words = heading.innerHTML.split(' ');
//   words[0] = `<span class="introducing">${words[0]}</span>`;
//   heading.innerHTML = words.join(' ');
// });
// }, 1000);

//   }
    $('a.header__icon-wrapper[aria-controls="mini-cart"]').load(location.href + '  a.header__icon-wrapper[aria-controls="mini-cart"]>*',"");
              $("cart-drawer").load(location.href + " cart-drawer>*","");   
if ($(window).width() < 1000)
    {
        $('.nav-media-data').on('DOMSubtreeModified', function(){
setTimeout(function(){
               $('.nav-media-data video').each(function() {
                  this.pause();
                });
}, 1000);
        });
    }
  $(document).on('click','.collection-quickview .block-swatch__item', function(e) { 
 
    var varids = [];
    $(this).parents('.block-swatch-list').find('.block-swatch__item').removeClass('active');
    $(this).addClass('active');
     $(this).parents('.collection-quickview').find(".block-swatch__item.active").each(function() {
          varids.push($(this).text());
    });
    if( varids.length == 1){
      var finalID = $(this).parents('.collection-quickview').find(".quick-option-select option[data-first*='"+varids[0]+"'][data-second*='"+varids[0]+"']").data('variantid');
    $(this).parents('.collection-quickview').find('.final-var-id').val(finalID);
      $(this).parents('.collection-quickview').find('.product-item__quick-form .button--outline span span').text($(this).parents('.collection-quickview').find(".quick-option-select option[data-first*='"+varids[0]+"'][data-second*='"+varids[0]+"']").data('var-price'));
    }  
    else{
    var finalID = $(this).parents('.collection-quickview').find(".quick-option-select option[data-first*='"+varids[0]+"'][data-second*='"+varids[1]+"']").data('variantid');
    $(this).parents('.collection-quickview').find('.final-var-id').val(finalID);
      $(this).parents('.collection-quickview').find('.product-item__quick-form .button--outline span span').text($(this).parents('.collection-quickview').find(".quick-option-select option[data-first*='"+varids[0]+"'][data-second*='"+varids[1]+"']").data('var-price'));
    }
    });
    $(document).on('click','.collection-quickview .quantity-selector__button', function(e) {
      var finalQty = $(this).parents('.collection-quickview').find(".quantity-selector__input").val();
      $(this).parents('.collection-quickview').find('.final-qty').val(finalQty);
    });
$(".with-slider-variants .new-product-item .product-details__size, .with-slider-variants .cart_pro_slide .product-details__size").each(function(index) {
// console.log($(this).find('.product_option').length);  
if($(this).find('.product_option').length > 3){
      $(this).not('.slick-initialized').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      arrows:true,
      dots:false,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3           
          }
        },      
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 3            
          }
        }  
      ]
  });
}
})
    function variantslider() {  
  $(".collection_tab_content .new-product-item .product-details__size").each(function(index) {
if($(this).find('.product_option').length > 3){
      $(this).not('.slick-initialized').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      arrows:true,
      dots:false,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3           
          }
        },      
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 2            
          }
        },        
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 2      
          }
        }   
      ]
  });
}
})
    }

    variantslider();
    
    $('.art_image_grid_section .image-grid__gallery').not('.slick-initialized').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      arrows:true,
      dots:true,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
             dots:true  
          }
        },      
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 3 ,
             dots:true ,
             arrows:false,
          }
        },        
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 2,
            dots:true  ,
             arrows:false,        
          }
        }   
      ]
  });
    $(".hiw_image_text_slider").not('.slick-initialized').slick({
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:false,
      adaptiveHeight: true
  });
    $('.community_become_section .multi-column__inner').not('.slick-initialized').slick({     
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      arrows:false,
      dots:false,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
             dots:true  
          }
        },      
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 2 ,
             dots:true  
          }
        },        
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 1,
            dots:true            
          }
        }   
      ]
  });
 $(".section-hair-care .main-content-slider-section-hair-care").not('.slick-initialized').slick({
      dots: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows:true,        
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2        
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
               arrows:false,
            dots:true,
            centerMode:true,
            centerPadding:'43px'
          }
        }   
      ]
  });
     $(".section-celebrate-coffee .main-block-slider-coffee-img").not('.slick-initialized').slick({
      dots: false,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
       centerMode:true,
            centerPadding:'177px',
      arrows:true,        
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            centerPadding:'30px',
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
               arrows:false,
            dots:true,
            centerPadding:'22px',
          }
        }
      ]
  });
 $(".section-img-slider-text .left-side-image-slider").not('.slick-initialized').slick({
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:true,
   responsive: [  
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
               arrows:true,
            dots:true,
            centerPadding:'22px',
          }
        }
      ]
  });
  $(document).on('click','.video-play-pause-grid', function () { 
    var d_id = $(this).children('button').data('id');
    $('#'+d_id).show(); 
    $('#'+d_id).addClass('open'); 
    $('.product_coffee_img').removeClass('img_hide');
    $('.product_coffee_modal iframe').hide();
    $('.coffee-video-play-pause').show();   
    $('body').addClass('model_open');

    $('.instructions_video_block iframe').hide();
    $('.video-play-pause-url,.product_coffee_see_img').show();

    $(".coffee_item iframe").each(function() {
    var iframeSrc = $(this)[0].src.replace('&autoplay=1','');
    $(this)[0].src = iframeSrc;
    });

  });
  $('.product_coffee_close_modal').on('click',function () {
      $('body').removeClass('model_open');
      $('.product_coffee_modal').hide();
    var iframeSrc =  $('.product_coffee_modal.open iframe')[0].src.replace('&autoplay=1','');
		$('.product_coffee_modal.open iframe')[0].src = iframeSrc;
     $('.product_coffee_modal').removeClass('open'); 
      $('.product_coffee_modal .instructions_video video').trigger("pause");   
      $('.product_coffee_img').removeClass('img_hide');
      $('.product_coffee_modal iframe').hide();
      $('.coffee-video-play-pause').show();   
    });
    $('.product_coffee_modal').on('click', function(e) {
      if (e.target !== this)
        return;
      $('body').removeClass('model_open');
      $('.product_coffee_modal').hide();
       var iframeSrc =  $('.product_coffee_modal.open iframe')[0].src.replace('&autoplay=1','');
		$('.product_coffee_modal.open iframe')[0].src = iframeSrc;
      $('.product_coffee_modal').removeClass('open'); 
      $('.product_coffee_modal .instructions_video video').trigger("pause");
    });
  $(document).on("click", ".video-play-pause", function () {
    $(this).hide();
    $(".section-hair-care .main-content-slider-section-hair-care video").trigger("pause");
    $(".instructions_video video").trigger("pause");
    $(this).parent().find("video").trigger("play");  
    $(this).parents('.single-slide-section-hair-care').find('.video-comp-iframe')[0].src += "&autoplay=1";
    $(this).parent().find(".video-comp-image").hide();
  });
  $(document).on("click", ".product_coffee_main .coffee-video-play-pause", function () {    
      $(this).hide(); 
     // var img_height = $('.product_coffee_modal .review_tab_content').outerHeight();
      var v_img_height = $('.product_coffee_modal.open .product_coffee_img').height(),
          v_img_width =  $('.product_coffee_modal.open .product_coffee_img').width();
      $('.product_coffee_modal iframe').css({'height':v_img_height,'width':v_img_width});     
      $('.product_coffee_modal.open iframe')[0].src.replace('&autoplay=1','')
      $('.product_coffee_img').addClass('img_hide');
      $('.product_coffee_modal.open iframe').show();  
      if($('.product_coffee_modal.open iframe')[0].src.includes("autoplay")){
         $('.product_coffee_modal.open iframe')[0].src.replace('&autoplay=0','&autoplay=1');
      }else{
         $('.product_coffee_modal.open iframe')[0].src += "&autoplay=1";  
      }
  });
   $(document).on("click", ".video-play-pause-url", function (e) {
     e.preventDefault();
     e.stopPropagation();      
    

      $('.instructions_video_block iframe').hide();
      $('.video-play-pause-url,.product_coffee_see_img').show();
      $(this).hide();
      $(this).parent().find('img').hide();
      $(this).parent().find('iframe').show();
     var img_height = $('.instructions_video img').outerHeight();
     $('.instructions_video iframe').css('height',img_height);
   
     // if($('.instructions_without_dropmenu').hasClass('active')){ 
     // $('.instructions_without_dropmenu.active iframe')[0].src.replace('&autoplay=1','')
     // if($('.instructions_without_dropmenu.active iframe')[0].src.includes("autoplay")){
     //     $('.instructions_without_dropmenu.active iframe')[0].src.replace('&autoplay=0','&autoplay=1');
     //  }else{
     //     $('.instructions_without_dropmenu.active iframe')[0].src += "&autoplay=1";  
     //  }
     // }

     // if($('.instructions_with_dropmenu').hasClass('active')){
     // $('.instructions_with_dropmenu.active iframe')[0].src.replace('&autoplay=1','')
     // if($('.instructions_with_dropmenu.active iframe')[0].src.includes("autoplay")){
     //     $('.instructions_with_dropmenu.active iframe')[0].src.replace('&autoplay=0','&autoplay=1');
     //  }else{
     //     $('.instructions_with_dropmenu.active iframe')[0].src += "&autoplay=1";  
     //  }
     // }     
   
     // 13-06 start
   //   if($('.instructions_without_dropmenu').hasClass('active')){  
   //   var iframeSrc =  $('.instructions_without_dropmenu.active iframe')[0].src.replace('&autoplay=1','');
   //   $('.instructions_without_dropmenu.active iframe')[0].src = iframeSrc;
   // }
   //   if($('.instructions_with_dropmenu').hasClass('active')){   
   //   var iframeSrc1 =  $('.instructions_with_dropmenu.active iframe')[0].src.replace('&autoplay=1','');
   //   $('.instructions_with_dropmenu.active iframe')[0].src = iframeSrc1;
   //   }

   //   var iframeSrc1 =  $(this).parents(".instructions_video_block").find("iframe")[0].src += "&autoplay=1";
   //   $(this).parents(".instructions_video_block").find("iframe")[0].src = iframeSrc1;
     
     // 13-06 end

    $(".coffee_item iframe").each(function() {           
      var iframeSrc =  $(this)[0].src.replace('&autoplay=1','');
       $(this)[0].src = iframeSrc;    
    });
    
     var iframeSrc1 =  $(this).parents(".instructions_video_block").find("iframe")[0].src += "&autoplay=1";
     $(this).parents(".instructions_video_block").find("iframe")[0].src = iframeSrc1;
  });
   $(window).resize(function () {
     var img_height = $('.instructions_video img').outerHeight();
     $('.instructions_video iframe').css('height',img_height);
      var v_img_height = $('.product_coffee_modal.open .product_coffee_img').height(),
          v_img_width =  $('.product_coffee_modal.open .product_coffee_img').width();
      $('.product_coffee_modal iframe').css({'height':v_img_height,'width':v_img_width});
  });
   $(document).on("click", ".instructions_video_block iframe", function (e) {     
     e.preventDefault();
     e.stopPropagation();     
   });
   $(document).on("click", function () { 
      $('.instructions_video_block iframe').hide();
      $('.video-play-pause-url,.product_coffee_see_img').show();
   if($('.instructions_without_dropmenu').hasClass('active')){  
     var iframeSrc =  $('.instructions_without_dropmenu.active iframe')[0].src.replace('&autoplay=1','');
     $('.instructions_without_dropmenu.active iframe')[0].src = iframeSrc;
   }
     if($('.instructions_with_dropmenu').hasClass('active')){   
     var iframeSrc1 =  $('.instructions_with_dropmenu.active iframe')[0].src.replace('&autoplay=1','');
     $('.instructions_with_dropmenu.active iframe')[0].src = iframeSrc1;
     }
     
  });
  $(".section-hair-care video").on("pause", function () {
    $(this).parent().find(".video-play-pause").show();
  });
  $(".section-hair-care video").on("playing", function () {
    $(this).parent().find(".video-play-pause").hide();
  });
  $(".section-hair-care .main-content-slider-section-hair-care").on("afterChange",function (event, slick, currentSlide, nextSlide) {
      $(".section-hair-care .main-content-slider-section-hair-care video").trigger("pause");
  });
  $(document).on("click", ".section-hair-care video", function () {
    $(this).parent().find("video").trigger("pause");
  });
 $(".instructions_video video").on("pause", function () {
    $(this).parent().find(".video-play-pause").show();
  });
  $(".instructions_video video").on("playing", function () {
    $(this).parent().find(".video-play-pause").hide();
  });
  $(document).on("click", ".instructions_video video", function () {
    $(this).parent().find("video").trigger("pause");
  });
    /* $('.home-multi-column .multi-column__inner').not('.slick-initialized').slick({
        speed: 8000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: false,
    cssEase: 'linear',
    slidesToShow: 1,
    draggable:false,
    focusOnSelect:false,
    pauseOnFocus:false,
    pauseOnHover:false,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
  });  */
  /* if($('.home-multi-column .multi-column__inner .slick-dots li').length > 1){
     $('.home-multi-column .multi-column__inner .slick-dots').removeClass('hide');  
  }else{
    $('.home-multi-column .multi-column__inner .slick-dots').addClass('hide');  
  } */
  $('.home-multi-3column .multi-column__inner').not('.slick-initialized').slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      arrows:false,
      responsive: [ 
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 2       
          }
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 1.5 ,
             variableWidth: true
          }
        }   
      ]
  });
 $(".home-multi-3column.home5column .multi-column__inner").slick('unslick');
 $('.home-multi-3column.home5column .multi-column__inner').not('.slick-initialized').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 5,
      arrows:false,
      responsive: [ 
        {
          breakpoint: 999,          
          settings: {
             dots: true,
            slidesToShow: 2       
          }
        },
        {
          breakpoint: 749,
          settings: {
            dots: true,           
            slidesToShow: 1.35,
            centerMode: true,
            centerPadding: '20px',         
          }
        }   
      ]
  });
    if($('.home-multi-3column').length > 1){
      $('.home-multi-3column').each(function () {
         if($(this).find('.multi-column__inner .slick-dots li').length > 1){
        $(this).find(' .multi-column__inner .slick-dots').removeClass('hide');  
      }else{
        $(this).find('.multi-column__inner .slick-dots').addClass('hide');  
      }
      });      
    }else{
       if($('.home-multi-3column .multi-column__inner .slick-dots li').length > 1){
         $('.home-multi-3column .multi-column__inner .slick-dots').removeClass('hide');  
      }else{
        $('.home-multi-3column .multi-column__inner .slick-dots').addClass('hide');  
       }
    }
     $('.home-featured-collections .product-list__inner').not('.slick-initialized').slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      arrows:false,
      draggable:false,
      touchMove:false,
      swipe: true,
      responsive: [ 
        {
          breakpoint: 1299,
          settings: {
            slidesToShow: 3       
          }
        },
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '60px',
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '60px',
          }
        }    
      ]
  });
  if($('.home-featured-collections .product-list__inner .slick-dots li').length > 1){
     $('.home-featured-collections .product-list__inner .slick-dots').removeClass('hide');  
  }else{
    $('.home-featured-collections .product-list__inner .slick-dots').addClass('hide');  
  }
  $('.grid_reviews_images').not('.slick-initialized').slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      arrows:false,
      responsive: [ 
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 3       
          }
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 1.56            
          }
        }   
      ]
  });
  if($('.grid_reviews_images .slick-dots li').length > 1){
     $('.grid_reviews_images .slick-dots').removeClass('hide');  
  }else{
    $('.grid_reviews_images .slick-dots').addClass('hide');  
  }
    if($('.personal_images_section .community_personal_text_mobile').children().length == 0){
      $('.community_banner').addClass('text-hide');
    }else{
      $('.community_banner').removeClass('text-hide');
    }
    $(window).resize(function () {
      setTimeout(function(){ 
      /* if($('.home-multi-column .multi-column__inner .slick-dots li').length > 1){
       $('.home-multi-column .multi-column__inner .slick-dots').removeClass('hide');  
     }else{
       $('.home-multi-column .multi-column__inner .slick-dots').addClass('hide');  
    }     */  
    if($('.grid_reviews_images .slick-dots li').length > 1){
       $('.grid_reviews_images .slick-dots').removeClass('hide');  
    }else{
      $('.grid_reviews_images .slick-dots').addClass('hide');  
    }
    if($('.home-featured-collections .product-list__inner .slick-dots li').length > 1){
     $('.home-featured-collections .product-list__inner .slick-dots').removeClass('hide');  
    }else{
      $('.home-featured-collections .product-list__inner .slick-dots').addClass('hide');  
    }      
 if($('.home-multi-3column.home5column').length > 1){
      $('.home-multi-3column.home5column').each(function () {
         if($(this).find('.multi-column__inner .slick-dots li').length > 1){
        $(this).find(' .multi-column__inner .slick-dots').removeClass('hide');  
      }else{
        $(this).find('.multi-column__inner .slick-dots').addClass('hide');  
      }
      });      
    }else{
       if($('.home-multi-3column.home5column .multi-column__inner .slick-dots li').length > 1){
         $('.home-multi-3column.home5column .multi-column__inner .slick-dots').removeClass('hide');  
      }else{
        $('.home-multi-3column.home5column .multi-column__inner .slick-dots').addClass('hide');  
       }
    }
     if($('.home-multi-3column').length > 1){
      $('.home-multi-3column').each(function () {
         if($(this).find('.multi-column__inner .slick-dots li').length > 1){
        $(this).find(' .multi-column__inner .slick-dots').removeClass('hide');  
      }else{
        $(this).find('.multi-column__inner .slick-dots').addClass('hide');  
      }
      });      
    }else{
       if($('.home-multi-3column .multi-column__inner .slick-dots li').length > 1){
         $('.home-multi-3column .multi-column__inner .slick-dots').removeClass('hide');  
      }else{
        $('.home-multi-3column .multi-column__inner .slick-dots').addClass('hide');  
       }
    }
   }, 1000); 
  });
    if($('.collection_list_section .container').width() < $('.collection_list_tabs').width()){
      $('.collection_list_tabs').addClass('flex-scroll');
    }else{
       $('.collection_list_tabs').removeClass('flex-scroll');
    }
     $(window).resize(function() {
    if($('.collection_list_section .container').width() < $('.collection_list_tabs').width()){
      $('.collection_list_tabs').addClass('flex-scroll');
    }else{
       $('.collection_list_tabs').removeClass('flex-scroll');
    }
 });
    $('.view_review_btn').on('click',function () {
      var id = $(this).attr('data-id');
      $('#'+id).show();
      $('body').addClass('model_open');
    });
    $(document).on('click','.review_close_modal',function () {
      $('body').removeClass('model_open');
      $('.review_tab_modal').hide();
    });
    $('.review_tab_modal').on('click', function(e) {
      if (e.target !== this)
        return;
      $('body').removeClass('model_open');
          $('.review_tab_modal').hide();
    });
    $('.collection_maker_btn').on('click',function () {      
      $('#collection_maker_popup').show();
      $('body').addClass('model_open');
      $('.product_left li.product1_1:first').addClass('active');
      $('.product_right li.product2_1:first').addClass('active'); 
      var d_title = $('.product_left li.product1_1:first').text()
          , d_url = $('.product_left li.product1_1:first').data('url')
          , d_price = $('.product_left li.product1_1:first').data('price')
          , d_capacity = $('.product_left li.product1_1:first').data('capacity')
          , d_material = $('.product_left li.product1_1:first').data('material')
          , d_accessories = $('.product_left li.product1_1:first').data('accessories')
          , d_edition = $('.product_left li.product1_1:first').data('edition')
          , d_appearance = $('.product_left li.product1_1:first').data('appearance')
          , pro_id = $('.product_left li.product1_1:first').data('pro-id');
    $('.product_left span.title font').text(d_title);
    $('.product_left .shop_btn').attr('href',d_url);
    $('.product_left .price span').text(d_price);
    $('.product_left .capacity span').text(d_capacity);
    $('.product_left .material span').text(d_material);
    $('.product_left .accessories span').text(d_accessories);
    $('.product_left .edition span').text(d_edition);
    $('.product_left .appearance span').text(d_appearance);
    $('.product_left .quick-add').hide();
    $('.product_left .hidden-cart-'+pro_id).show();
    var d_title1 = $('.product_right li.product2_1:first').text(), 
        d_url1 = $('.product_right li.product2_1:first').data('url'), 
        d_price1 = $('.product_right  li.product2_1:first').data('price') ,
        d_capacity1 = $('.product_right  li.product2_1:first').data('capacity'),
        d_material1 = $('.product_right  li.product2_1:first').data('material'),
        d_accessories1 = $('.product_right li.product2_1:first').data('accessories') ,
        d_edition1 = $('.product_right li.product2_1:first').data('edition'),
        d_appearance1 = $('.product_right  li.product2_1:first').data('appearance'),
        pro_id = $('.product_right li.product2_1:first').data('pro-id');
    $('.product_right span.title font').text(d_title1);
    $('.product_right .shop_btn').attr('href',d_url1);
    $('.product_right .price span').text(d_price1);
    $('.product_right .capacity span').text(d_capacity1);
    $('.product_right .material span').text(d_material1);
    $('.product_right .accessories span').text(d_accessories1);
    $('.product_right .edition span').text(d_edition1);
    $('.product_right .appearance span').text(d_appearance1);
    $('.product_right .quick-add').hide();
    $('.product_right .hidden-cart-'+pro_id).show();
      var p_s_text = $('.product_left ul li.pro_title .title font').text(),p_s_text2 = $('.product_right ul li.pro_title .title font').text();
      $('.product_img img').removeClass('active');
      $('.product_left .product_img img[alt="'+p_s_text+'"]').addClass('active');
      $('.product_right .product_img img[alt="'+p_s_text2+'"]').addClass('active');
    });
    $(document).on('click','.collection_close_modal',function () {
      $('body').removeClass('model_open');
      $('#collection_maker_popup').hide();
    });
    $('.review_tab_modal .quick-add .product-item__cta').on('click' , function(){
      setTimeout(function() {
           $('body').removeClass('model_open');
            $('#collection_maker_popup').hide();
      }, 1500);
    });
    $('.review_tab_modal').on('click', function(e) {
      if (e.target !== this)
        return;
      $('body').removeClass('model_open');
          $('#collection_maker_popup').hide();
    });
    $('.survey-section .product_survey_btn').on('click',function () {      
          $('#product_survey_popup').show();
          $('body').addClass('model_open');
    });
    $('.product_survey_close_modal').on('click',function () {
      $('body').removeClass('model_open');
      $('#product_survey_popup').hide();
    });
$('#product_survey_popup').on('click', function(e) {
      if (e.target !== this)
        return;
      $('body').removeClass('model_open');
          $('#product_survey_popup').hide();
    });
    if($(".slider-recipe").length > 0){ 
    function tabslider() {
      if($(".slider-recipe .recipe_tab_content.active").hasClass("slick-initialized")){
$(".slider-recipe .recipe_tab_content.active").slick('unslick');
      }
      $(".recipe_controls .slick-slider-dots").html("");
      $(".slider-recipe .recipe_tab_content.active").not('.slick-initialized').slick({
      dots: false,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows:true,   
      prevArrow: $('.recipe_controls .prev-arrow'),
      nextArrow: $('.recipe_controls .next-arrow'),
      appendDots: $('.recipe_controls .slick-slider-dots'),
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,     
          }
        },
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 2 ,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 749,
          settings: "unslick"
          /* settings: {
            slidesToShow: 1.3,
            slidesToScroll: 1,              
          } */
        }   
      ]
  });
$('.slider-recipe .recipe_tab_content.active').slick('setPosition');
    }
    tabslider();
      if( $(".slider-recipe .recipe_tab_content.active .border-with-recipe").length == 0){
        $('.Recipes_comingsoon_block').show();
        $('.all-recipe-link').hide();
      }else{
        $('.Recipes_comingsoon_block').hide();
        $('.all-recipe-link').show();       
      }
      setTimeout(function () {
        if( $(".slider-recipe .recipe_tab_content.active .border-with-recipe").length == 0){
        $('.Recipes_comingsoon_block').show();
        $('.all-recipe-link').hide();
      }else{
        $('.Recipes_comingsoon_block').hide();
        $('.all-recipe-link').show();       
      }
      },300);
    $('.center-recipe-tab li').on('click',function () {     
      var tagattr=$(this).attr("data-attr-tag");
      $('.center-recipe-tab li').removeClass("active");
      $(this).addClass("active");
      $(".slider-recipe .recipe_tab_content").each(function(){
        if($(this).attr("data-attr-blog") == tagattr){
          $(this).addClass("active");
        }
        else{
          $(this).removeClass("active");
        }
      });      
      //var lilen=$(".slider-recipe .recipe_tab_content.active div").length;
      if( $(".slider-recipe .recipe_tab_content.active .border-with-recipe").length == 0){
        $('.Recipes_comingsoon_block').show();
        $('.all-recipe-link').hide();
      }else{
        $('.Recipes_comingsoon_block').hide();
        $('.all-recipe-link').show();
        tabslider();    
      }        
    });
    }
     $('.footer__item--links p.footer__item-title').on('click',function (){  
      if($(this).hasClass('active')){
        $(this).removeClass('active');
        $(this).next().toggle();   
      }else{
        $('.footer__item--links p.footer__item-title').removeClass('active');
        $('.footer__item--links .footer__item-content').hide(); 
        $(this).addClass('active');
        $(this).next().toggle();  
      }
     });
    $(".product-quantity-select").on("change",function(){        
        $(this).parents('.product-form').find('.quantity-selector__input').val($(this).val());
        $(this).parents('.product-form').find(".quantity-selector__button").last().click();    
   });
 $('.main-slider-what-include').not('.slick-initialized').slick({
      dots: true,
      infinite: false,
      slidesToShow: 5,
      arrows:false,
      responsive: [ 
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 577,
          settings: {
            slidesToShow: 2.3
          }
        },
        {
          breakpoint: 356,
          settings: {
            slidesToShow: 1.8
          }
        }
      ]
  });
if($('.main-slider-what-include .slick-dots li').length > 1){
     $('.main-slider-what-include .slick-dots').show();
   }
  else{
    $('.main-slider-what-include .slick-dots').hide();
  }
   $(window).resize(function () {
      setTimeout(function(){ 
     if($('.main-slider-what-include .slick-dots li').length > 1){
     $('.main-slider-what-include .slick-dots').show();
   }
  else{
    $('.main-slider-what-include .slick-dots').hide();
  }
   }, 1000); 
  });
    $(document).on('click','.product__info span.stamped-badge',function(){    
       $("html, body").animate({ scrollTop:  $('.template-product div#stamped-main-widget').offset().top - $('#shopify-section-header').outerHeight() }, 1000);
    });
    $(document).on('click','.welcoment_newsletter_section button[type="button"]',function(){      
        $('.welcoment_newsletter_section .klaviyo-form ').removeClass('welcoment_klaviyo_form').addClass('welcoment_klaviyo_form_success');
      setTimeout(function(){
         $('.welcoment_newsletter_section .klaviyo-form ').removeClass('welcoment_klaviyo_form').addClass('welcoment_klaviyo_form_success');
      }, 2000); 
    });  
  
    function ValidateEmail(email) {
        var expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        return expr.test(email);
    };
    
    $(document).on('click','footer .footer__item-content .needsclick button[type=button]',function(){      
      if (ValidateEmail($('.footer__item-content input[type=email]').val())) {
        $('.footer__item--newsletter').addClass('newsletter_klaviyo_form_success');
        setTimeout(function(){
             $('.footer__item--newsletter').addClass('newsletter_klaviyo_form_success');
        }, 1000); 
        setTimeout(function(){
             $('.footer__item--newsletter').addClass('newsletter_klaviyo_form_success');
        }, 2000); 
      }
    });
setTimeout(function(){ 
    var img_src = 'https://cdn.shopify.com/s/files/1/0601/8783/6659/files/icons8-shipping_1.svg?v=1699437857';
   $('.kaching-icon-block--icon img[alt="Free US Shipping"]').attr('src',img_src);
  $('.template-product div#stamped-main-widget .stamped-header-title').text('Reviews');
  $('.footer__item-content input[type=email]').attr('placeholder','Email');
  if($('.welcoment_newsletter_section button[type=button]').text() != 'Sign Up Now'){
        $('.welcoment_newsletter_section button[type=button]').text('Sign Up Now');
    $('.welcoment_newsletter_section .klaviyo-form ').addClass('welcoment_klaviyo_form');
    }
  }, 5000); 
const myInterval = setInterval(myTimer, 1000);
function myTimer() {
  var img_src = 'https://cdn.shopify.com/s/files/1/0601/8783/6659/files/icons8-shipping_1.svg?v=1699437857';
  if($('.kaching-icon-block--icon img[alt="Free US Shipping"]').attr('src') == img_src){
     clearInterval(myInterval);
  }else{  
   $('.kaching-icon-block--icon img[alt="Free US Shipping"]').attr('src',img_src);
  }   
}
    $('.coffee_icon_item.coffee_icon_item1 .icon_img0, .coffee_icon_item.coffee_icon_item2 .icon_img0').on('click',function(){    
       if($(this).hasClass('active')){             
            if($('.instructions_without_dropmenu').hasClass('active')){        
              var iframeSrc =  $('.instructions_without_dropmenu.active iframe')[0].src.replace('&autoplay=1','');
              $('.instructions_without_dropmenu.active iframe')[0].src = iframeSrc;
            }
            
            if($('.instructions_with_dropmenu').hasClass('active')){   
              var iframeSrc1 =  $('.instructions_with_dropmenu.active iframe')[0].src.replace('&autoplay=1','');
              $('.instructions_with_dropmenu.active iframe')[0].src = iframeSrc1;
            }
         
           $(this).toggleClass('active');
           $(this).parents('.coffee_item_row').toggleClass('active');
           $(this).parent().next().toggleClass('active');
       }else{
           $(this).toggleClass('active');
           $(this).parents('.coffee_item_row').toggleClass('active');
           $(this).parent().next().toggleClass('active');
       } 
  });
  $('.coffee_icon_item .icon_img3').on('click',function(){    
     $(this).toggleClass('active');
     $(this).parent().next().toggleClass('active');
     if($('.coffee_top_slider .slick-dots li,#coffee_item_block1  .slick-dots li,#coffee_item_block2   .slick-dots li,#coffee_item_block3   .slick-dots li').length > 1){
     $('.coffee_top_slider .slick-dots,#coffee_item_block1   .slick-dots,#coffee_item_block2  .slick-dots ,#coffee_item_block3   .slick-dots').removeClass('hide');  
  }else{
    $('.coffee_top_slider .slick-dots,#coffee_item_block1   .slick-dots,#coffee_item_block2  .slick-dots ,#coffee_item_block3  .slick-dots').addClass('hide');  
  }
     $('.coffee_instructions_slider').slick('refresh');
    setTimeout(function(){
      $('.coffee_instructions_slider').slick('refresh');
    },500);
  });
   $('.coffee_top_slider,.coffee_instructions_slider').not('.slick-initialized').slick({
      dots: true,
      infinite: false,
      slidesToShow: 3,
      arrows:false ,
      responsive: [ 
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2.5
          }
        },
        {
          breakpoint: 577,
          settings: {
            slidesToShow: 1.5
          }
        }    
      ]
  });
$('.coffee_instructions_slider').slick('refresh');
  if($('.coffee_top_slider .slick-dots li,#coffee_item_block1  .slick-dots li,#coffee_item_block2   .slick-dots li,#coffee_item_block3   .slick-dots li').length > 1){
     $('.coffee_top_slider .slick-dots,#coffee_item_block1   .slick-dots,#coffee_item_block2  .slick-dots ,#coffee_item_block3   .slick-dots ').removeClass('hide');  
  }else{
    $('.coffee_top_slider .slick-dots,#coffee_item_block1   .slick-dots,#coffee_item_block2  .slick-dots ,#coffee_item_block3  .slick-dots ').addClass('hide');  
  }
  $(window).resize(function () {
    setTimeout(function(){
         if($('.coffee_top_slider .slick-dots li,#coffee_item_block1  .slick-dots li,#coffee_item_block2   .slick-dots li,#coffee_item_block3   .slick-dots li').length > 1){
     $('.coffee_top_slider .slick-dots,#coffee_item_block1   .slick-dots,#coffee_item_block2  .slick-dots ,#coffee_item_block3   .slick-dots ').removeClass('hide');  
  }else{
    $('.coffee_top_slider .slick-dots,#coffee_item_block1   .slick-dots,#coffee_item_block2  .slick-dots ,#coffee_item_block3  .slick-dots ').addClass('hide');  
  }
   }, 1000); 
  });
 $('.coffee_top_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){  
   var id = $('.coffee_top_slider .slick-active').data('id');
   $('.coffee_item.coffee_item_row').hide();
   $('#'+id).show();
   $('.coffee_instructions_slider').slick('refresh');
}).trigger('afterChange');   
// function addBodyClass1() {
    if (!$(".cart_product.new-product-item").hasClass("slick-initialized")) {
 $('.cart_product.new-product-item').not('.slick-initialized').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      centerPadding: '99.5px',
      arrows:true,
      responsive: [ 
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '60px',
            infinite: true,
            arrows:false,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '66.5px',
            infinite: true,
            arrows:false,
          }
        }    
      ]
  });
}
    
    if($('.empty_cart_product .product-item .product-item__quick-form .product-form__add-button').length == 0){
    var c_empty_btn = '<button is="loader-button" type="submit" class="product-form__add-button button button--ternary button--full" tabindex="0"><span class="loader-button__text">Add to Cart</span><span class="loader-button__loader" hidden=""><div class="spinner"><svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle></svg></div></span></button>';
       $('.empty_cart_product  .product-item__quick-form').append(c_empty_btn);    
    }
      $(document).on("click", ".quantity-selector__button,.mini-cart .line-item__remove-button", function () {
      
         if($('.empty_cart_product .product-item .product-item__quick-form .product-form__add-button').length == 0){
      setTimeout(function(){ 
        var c_empty_btn = '<button is="loader-button" type="submit" class="product-form__add-button button button--ternary button--full" tabindex="0"><span class="loader-button__text">Add to Cart</span><span class="loader-button__loader" hidden=""><div class="spinner"><svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle></svg></div></span></button>';
       $('.empty_cart_product  .product-item__quick-form').append(c_empty_btn);
       $('.empty_cart_product  .product-item__quick-form .loader-button__text').text('Add to Cart');
      }, 3000);          
         }
   }); 
     $("cart-drawer").bind("DOMSubtreeModified", function() { 
           if (!$(".cart_product.new-product-item").hasClass("slick-initialized")) {
 $('.cart_product.new-product-item').not('.slick-initialized').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      centerPadding: '99.5px',
      arrows:true,
      responsive: [ 
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '60px',
            infinite: true,
            arrows:false,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '66.5px',
            infinite: true,
             arrows:false,
          }
        }    
      ]
  });
}
       setTimeout(function(){
       $(".with-slider-variants .cart_pro_slide .product-details__size").each(function(index) {
if($(this).find('.product_option').length > 3){
      $(this).not('.slick-initialized').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      arrows:true,
      dots:false,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3           
          }
        },      
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 3            
          }
        }  
      ]
  });
}
})
         },1000);

        if( $('.mini-cart .add_cart .slick-track').children().length == 0){
        $('.additem_slider').addClass('slide_hide'); 
       }else{
         $('.additem_slider').removeClass('slide_hide'); 
       }
       
     });  
  // }
    function addBodyClass() {
    if (!$(".new-product-item.add_cart").hasClass("slick-initialized")) {
       $('.new-product-item.add_cart').not('.slick-initialized').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1.45,
      arrows:true,      
      prevArrow: $('.additem_controls .prev-arrow'),
      nextArrow: $('.additem_controls .next-arrow'),
      responsive: [ 
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 1.3,           
          }
        }           
      ]
  });
       $('.new-product-item.add_cart').on('afterChange', function(event, slick, currentSlide){
        if($('.additem_controls .next-arrow').hasClass('slick-disabled')){
          $('.new-product-item.add_cart').slick('slickGoTo', 0);
        }
      });
    }
  }
  setInterval(addBodyClass, 200);
    $('.header__icon-wrapper[aria-controls="mini-cart"]').on('click' , function(){
     if( $('.cart_drawer .product-item').hasClass('product-item--sold-out') ){
     $('cart-drawer').find('.product-item .button .loader-button__text').empty().append('Coming Soon');  
       $('cart-drawer').find('.add_cart .product-item .button .loader-button__text').empty().append('Coming Soon');
 }else{
       $('cart-drawer').find('.add_cart .product-item .button .loader-button__text').empty().append('Add to Cart');
 }
})
     $(document).on("click", ".discount_code_remove", function () { 
      var discountCode = document.getElementById("discount_code").value;
      console.log(discountCode);
      fetch('/discount/'+discountCode)
        .then(function() {
            fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              updates: {},
            }),
          }).then(cart => {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
              // upsellplusapp.init_drawer_offer();
              $('.discount_boxes').show();
              $('.discount_boxes .discounr_code').text(discountCode);
              document.getElementById("discount-message").innerHTML="<div class='show-discount'>Discount will be applied at checkout: <span>" + discountCode + "</span></div>";
          })
          .catch(error => {
            console.error('Error updating cart:', error);
          });
          document.getElementById("discount_code").value = '';
        })
        .catch(function(error) {
          console.error('Error:', error);
        });
    });
    $(document).on('click','.discount-remove', function() {
      fetch('/discount/CLEAR')
          .then(function() {
              fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                updates: {},
              }),
            }).then(cart => {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
                // upsellplusapp.init_drawer_offer();
                document.getElementById("discount-message").innerHTML="";
            })
            .catch(error => {
              console.error('Error updating cart:', error);
            });
            document.getElementById("discount_code").value = '';
          })
          .catch(function(error) {
            console.error('Error:', error);
          });
    });
    $(document).on('click','.recipe_filter span.title', function(e) {    
      $(this).parent().toggleClass('active');
      e.preventDefault();
      e.stopPropagation();
    });
     $('.recipe_filter ul').on("click", function (e) {
        e.stopPropagation();
    });
    $(document).on("click", function () {
     $('.recipe_filter').removeClass('active');
    }); 
   freeShippingMsg();
    $(document).on('click','.quickview_btn', function(e) {
      var d_modal = $(this).attr('data-modal');
      $('#'+d_modal).show(); 
      $('#'+d_modal).addClass('open');
      $('body').addClass('model_open');
    });
    $(document).on('click','.cart_quickview_close', function(e) {     
     e.preventDefault();    
      $('.quickview_modal').hide();
      $('body').removeClass('model_open');
      $('cart-drawer').attr('open',true);
      setTimeout(function(){
       $('cart-drawer').attr('open',true);
     }, 5);
    });
 $(document).on('click','.pdp_quickview_close', function(e) {     
     e.preventDefault();    
      $('.quickview_modal').hide();
      $('.quickview_modal').removeClass('open');
      $('body').removeClass('model_open');
    });
    $(document).on('click','.blog_quickview_btn', function(e) {
      var d_modal = $(this).attr('data-modal');
      $('#'+d_modal).show();
      $('body').addClass('model_open');
    });
     $(document).on('click','.blog_quickview_close', function(e) {     
     e.preventDefault();         
      $('.quickview_modal').hide();
      $('body').removeClass('model_open');      
    });
    $('.quickview_modal').on('click', function(e) {
      if (e.target !== this)
        return;
      $('body').removeClass('model_open');
          $('.quickview_modal').hide();
    });
   $(document).on('change','.quickview_variants input[type="radio"]', function(e) {   
      var d_img = $(this).attr('data-image'),val = $(this).val(),id = $(this).attr('data-id');
      $(this).parents('.quickview_product_row').children('.quickview_product_image').children('img').attr('src',d_img);
      $(this).parents('.quickview_product_row').children('.quickview_product_image').children('img').attr('srcset',d_img);
      $(this).parents('.quickview__options').find('.color_name').text(val);
     $(this).parents('.quickview__options').next().find('input[name="id"]').val(id);
     if($(this).parent().hasClass('is-disabled')){
       $(this).parents('.quickview_product_info').find('.product-item__quick-form').find('.product-form__add-button').attr('disabled','true')
     }else{
       $(this).parents('.quickview_product_info').find('.product-item__quick-form').find('.product-form__add-button').removeAttr('disabled')
     }
    });
    $(document).on('click','.quickview_product_info .product-item__quick-form button[type=submit]', function(e) {
      setTimeout(function(){
      $(this).parents('.collection-quickview').find(".quantity-selector__input").val('1');
      $(this).parents('.collection-quickview').find(".final-qty").val(1);
        },300);
       $('.quickview_modal').hide();
       $('body').removeClass('model_open');
    });
   $('.personal_images.mobile_show').not('.slick-initialized').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 5,
      arrows:true,  
      prevArrow: $('.how_to_use_controls .prev-arrow'),
      nextArrow: $('.how_to_use_controls .next-arrow'),
      appendDots: $('.how_to_use_controls .slick-slider-dots'), 
       responsive: [
         {
          breakpoint: 1300,
          settings: {
            slidesToShow: 4,
          }
        }, 
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          }
        },        
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
          }
        }        
      ]
  }); 
        $('.multilingual_instructions_section .multi-column__inner').not('.slick-initialized').slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 3,     
      arrows:false,     
      responsive: [
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 2                   
          }
        },      
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1            
          }
        }  
      ]
  }); 
  //   $('.perfect_coffee_section .coffee_grid').not('.slick-initialized').slick({
  //     dots: true,
  //     infinite: false,
  //     speed: 300,
  //     slidesToShow: 4,     
  //     arrows:false,     
  //     responsive: [
  //       {
  //         breakpoint: 1199,
  //         settings: {
  //           slidesToShow: 3                   
  //         }
  //       },      
  //       {
  //         breakpoint: 989,
  //         settings: {
  //           slidesToShow: 2            
  //         }
  //       },     
  //       {
  //         breakpoint: 749,
  //         settings: {
  //           slidesToShow: 1,
  //           arrows:true            
  //         }
  //       }  
  //     ]
  // });
  // $('.perfect_coffee_section .coffee_grid').on('swipe', function(event, slick, direction) {
  //   event.preventDefault();   
  //   $('body, html').animate({scrollTop: $(".perfect_coffee_section").offset().top});  
  //   $('.coffee_icon_item.coffee_icon_item1 .icon_img0, .coffee_icon_item.coffee_icon_item2 .icon_img0,.coffee_icon_item .icon_img3').removeClass('active');
  //   $('.instructions_with_dropmenu,.instructions_without_dropmenu').removeClass('active');    
  // });
  // $('.perfect_coffee_section .slick-dots li button').on('click', function(e){
  //   e.preventDefault();   
  //   $('body, html').animate({scrollTop: $(".perfect_coffee_section").offset().top});  
  //   $('.coffee_icon_item.coffee_icon_item1 .icon_img0, .coffee_icon_item.coffee_icon_item2 .icon_img0,.coffee_icon_item .icon_img3').removeClass('active');
  //   $('.instructions_with_dropmenu,.instructions_without_dropmenu').removeClass('active');          
  // });
  // if($('.perfect_coffee_section .coffee_grid .slick-dots li').length > 1){
  //    $('.perfect_coffee_section .coffee_grid .slick-dots ').removeClass('hide');  
  // }else{
  //   $('.perfect_coffee_section .coffee_grid .slick-dots ').addClass('hide');  
  // }
  // $(window).resize(function () {
  //   setTimeout(function(){
  //    if($('.perfect_coffee_section .coffee_grid .slick-dots li').length > 1){
  //      $('.perfect_coffee_section .coffee_grid .slick-dots ').removeClass('hide');  
  //    }else{
  //     $('.perfect_coffee_section .coffee_grid .slick-dots ').addClass('hide');  
  //   }
  //     $('cart-drawer').find('.product-item .button .loader-button__text').empty().append('Add to Cart');
  //  }, 1000); 
  // });
  setTimeout(function(){
    if(!$(".compare_best_seller").hasClass("compare_page_section")){
    $('.compare_best_seller').find('.product-item .button .loader-button__text').empty().append('Shop');
    }
    $('product-recommendations').find('.product-item .button .loader-button__text').empty().append('Add to cart');
    if($('.welcoment_newsletter_section button[type=button]').text() != 'Sign Up Now'){
        $('.welcoment_newsletter_section button[type=button]').text('Sign Up Now');
       $('.welcoment_newsletter_section .klaviyo-form ').addClass('welcoment_klaviyo_form');
    }
     $('cart-drawer').find('.product-item .button .loader-button__text').empty().append('Add to Cart');
  }, 1000); 
   $(document).on("click",".mini-cart .line-item__remove-button",function(e) {
     var vid = parseInt(jQuery(this).attr('data-ind'));
          $.ajax({
            url: "/cart/change.js",
            type: "post",
            dataType:'json',
            data:  { quantity: 0, line:vid },
            success: function(cart){
              $('a.header__icon-wrapper[aria-controls="mini-cart"]').load(location.href + '  a.header__icon-wrapper[aria-controls="mini-cart"]>*',"");
              $("cart-drawer").load(location.href + " cart-drawer>*","");                      },
              error: function(err){       
              }
          }); 
    }); 
      $(document).on("change",".product_option input",function() {       
     var o_val = $(this).val(),
     o_id =  $(this).parents('.product-item__quick-form').find(".ph-variant option[data-first-value='" + o_val + "']").val(),
       o_price =  $(this).parents('.product-item__quick-form').find(".ph-variant option[data-first-value='" + o_val + "']").data('price'),
       o_src =  $(this).parents('.product-item__quick-form').find(".ph-variant option[data-first-value='" + o_val + "']").data('media-src');
      $(this).parents('.product-item__quick-form').find('input[name="id"]').val(o_id);
      $(this).parents('.product-item').find('.product-item__primary-image').attr('srcset',o_src);
      $(this).parents('.product-item').find('span.price').text(o_price);     
      if($(this).parent().hasClass('is-disabled')){
        $(this).parents('.product-item__quick-form').find('.product-form__add-button').attr('disabled','true');
         $(this).parents('.product-item__quick-form').find('.product-form__add-button').children('.loader-button__text').text('Coming Soon');
      }else{
        $(this).parents('.product-item__quick-form').find('.product-form__add-button').removeAttr('disabled');
        $(this).parents('.product-item__quick-form').find('.product-form__add-button').children('.loader-button__text').text('Add to Cart');
      }
      $(this).parents('.product-details__size').slick('refresh');
     }); 
     $(document).on('change', '.quickview_modal.collection-quickview .block-swatch__radio', function() {    
       var o_val = $(this).val(),d_id='',d_price=$('.collection-quickview.open .button[type="submit"] span.loader-button__text span').text(),d_src='';
       $(this).parents('.quickview_product_info').find(".ph-variant option").each(function(){
           var d_val = $(this).data('value');  
          if($(this).data('value').includes(o_val)){
             d_id = $(this).val(), d_src= $(this).data('media-src');
          }
       })
      $(this).parents('.quickview_product_info').find('input[name="id"]').val(d_id);
      $('.collection-quickview.open .quickview_product_image img').attr('srcset',d_src);
       $('.collection-quickview.open .quickview_product_info span.price').text(d_price);
     }); 
      $("cart-drawer").bind("DOMSubtreeModified", function() {  
       if($('.mini-cart__discount-badge').length > 0 ){
         $('.mini-cart #discount_code').hide();
       }else{
           $('.mini-cart #discount_code').show();
       }
      });   
    $(".tab_drawer_heading").click(function() { 
    if($(this).hasClass('d_active')) {       
        var d_activeTab = $(this).attr("rel"); 
        $("#"+d_activeTab).hide();
        $(this).removeClass("d_active");
    }else{
      $(".tab_content").hide();
      var d_activeTab = $(this).attr("rel"); 
      $("#"+d_activeTab).fadeIn();	  
	  $(".tab_drawer_heading").removeClass("d_active");
      $(this).addClass("d_active");	 
    }
    });
    setTimeout(function(){ 
        if($('#mpr-product-list').length > 0){      
          $('.warranty_main_section').addClass('warranty_only_form');
        }else{
           $('.warranty_main_section').removeClass('warranty_only_form');
        }     
      if( $('.mini-cart .add_cart .slick-track').children().length == 0){
        $('.additem_slider').addClass('slide_hide'); 
       }else{
         $('.additem_slider').removeClass('slide_hide'); 
       }
      }, 3000); 
     $(document).on("click",".warranty_main_section #mpr-product-inputs .form-group .btn-primary",function(e) {
      setTimeout(function(){ 
        if($('#mpr-product-list').length > 0){      
          $('.warranty_main_section').addClass('warranty_only_form');
        }else{
           $('.warranty_main_section').removeClass('warranty_only_form');
        }
       }, 300); 
       setTimeout(function(){ 
        if($('#mpr-product-list').length > 0){      
          $('.warranty_main_section').addClass('warranty_only_form');
        }else{
           $('.warranty_main_section').removeClass('warranty_only_form');
        }
       }, 1000); 
     }); 
    function linequalbox(){     
      setTimeout(function(){ 
      $('.product_detail_main li.accessories').css('height','');
      $('.product_detail_main li.price').css('height','');
      $('.product_detail_main li.capacity').css('height','');
      $('.product_detail_main li.material').css('height','');
      $('.product_detail_main li.appearance').css('height','');
      var highestBox = 0;
        $('.product_detail_main li.accessories').each(function(){  
                if($(this).height() > highestBox){  
                highestBox = $(this).height();  
        }
    });    
    $('.product_detail_main li.accessories').height(highestBox);
     var highestBox1 = 0;
        $('.product_detail_main li.price').each(function(){  
                if($(this).height() > highestBox1){  
                highestBox1 = $(this).height();  
        }
    });    
    $('.product_detail_main li.price').height(highestBox1);
     var highestBox2 = 0;
        $('.product_detail_main li.capacity').each(function(){  
                if($(this).height() > highestBox2){  
                highestBox2 = $(this).height();  
        }
    });    
    $('.product_detail_main li.capacity').height(highestBox2);
     var highestBox3 = 0;
        $('.product_detail_main li.material').each(function(){  
                if($(this).height() > highestBox3){  
                highestBox3 = $(this).height();  
        }
    });    
    $('.product_detail_main li.material').height(highestBox3);
    var highestBox4 = 0;
        $('.product_detail_main li.appearance').each(function(){  
                if($(this).height() > highestBox4){  
                highestBox4 = $(this).height();  
        }
    });    
    $('.product_detail_main li.appearance').height(highestBox4);
    }, 500);
    }
     $(document).on('click',function () {
        linequalbox();
    });
    $(window).resize(function(){     
      linequalbox();
    });
    $('.product_left .pro_title_dropmenu li').on('click',function(){
    var d_title = $(this).text(), d_url = $(this).data('url'), d_price = $(this).data('price') , d_capacity = $(this).data('capacity'), d_material = $(this).data('material') ,
       d_accessories = $(this).data('accessories') , d_appearance = $(this).data('appearance'), pro_id = $(this).data('pro-id'), d_edition = $(this).data('edition');
    $('.product_left span.title font').text(d_title);
    $('.product_left .shop_btn').attr('href',d_url);
    $('.product_left .price span').text(d_price);
    $('.product_left .capacity span').text(d_capacity);
    $('.product_left .material span').text(d_material);
    $('.product_left .edition span').text(d_edition);
    $('.product_left .accessories span').text(d_accessories);
    $('.product_left .appearance span').text(d_appearance);
    $('.product_left .quick-add').hide();
    $('.product_left .hidden-cart-'+pro_id).show();
    $('.product_left .pro_title_dropmenu li').removeClass('active');
    $(this).addClass('active');
    $('ul.pro_title_dropmenu').hide();
    $('.review_tab_content .product_item span.title').removeClass('active');
$( ".product_left .product_img img" ).each(function() {
  var asd = $( this ).attr('alt');
  var wer = $('.product1_1.active').text()
if(asd == wer){
    $(this).siblings().removeClass('active')
   $(this).addClass('active')
}
});
    });
    $('.product_right .pro_title_dropmenu li').on('click',function(){
        var d_title1 = $(this).text(), d_url1 = $(this).data('url'), d_price1 = $(this).data('price') , d_capacity1 = $(this).data('capacity'), d_material1 = $(this).data('material'),
      d_accessories1 = $(this).data('accessories') ,  d_appearance1 = $(this).data('appearance'), pro_id = $(this).data('pro-id'), d_edition1 = $(this).data('edition');
    $('.product_right span.title font').text(d_title1);
    $('.product_right .shop_btn').attr('href',d_url1);
    $('.product_right .price span').text(d_price1);
    $('.product_right .capacity span').text(d_capacity1);
    $('.product_right .material span').text(d_material1);
    $('.product_right .edition span').text(d_edition1);
    $('.product_right .accessories span').text(d_accessories1);
    $('.product_right .appearance span').text(d_appearance1);
    $('.product_right .quick-add').hide();
    $('.product_right .hidden-cart-'+pro_id).show();
    $('.product_right .pro_title_dropmenu li').removeClass('active');
    $(this).addClass('active');
    $('ul.pro_title_dropmenu').hide();
    $('.review_tab_content .product_item span.title').removeClass('active');
    $( ".product_right .product_img img" ).each(function() {
  var asd = $( this ).attr('alt');
  var wer = $('.product2_1.active').text()
if(asd == wer){
    $(this).siblings().removeClass('active')
   $(this).addClass('active')
}
});
    });
   $('.review_tab_content .product_item span.title').on('click',function(e){
     e.preventDefault();
     e.stopPropagation();
      $(this).toggleClass('active');
      $(this).next().toggle();
  });
   $('ul.pro_title_dropmenu').on("click", function (e) {
        e.stopPropagation();
    });
    $(document).on("click", function () {
        $('ul.pro_title_dropmenu').hide();
        $('.review_tab_content .product_item span.title').removeClass('active');
    }); 
    setTimeout(function(){ 
       StampedFn.loadBadges();
      }, 3000); 
   $('.product-item__quick-form .button,cart-drawer-recommendations .product-item__link,.product-form__add-button ,.quantity-selector__button,.mini-cart .line-item__remove-button,.shopify-section--header .header__icon-wrapper[aria-controls="mini-cart"]').on("click", function (e) { 
      setTimeout(function(){ 
       StampedFn.loadBadges();
      }, 1000); 
      setTimeout(function(){ 
       StampedFn.loadBadges();
      }, 3000); 
   });
    var bno = 1;
   $('.blog_main img').each(function(){
     $(this).addClass('blog-img'+bno);
     bno++;  
  }); 
    $(document).on("click", ".product-form__add-button", function (e) {
      if($('.loader-button__loader').attr('hidden') == 'hidden'){
         $(this).addClass('loader-true');
      }
      setTimeout(function(){ 
          $('.product-form__add-button').removeClass('loader-true');
      }, 2200); 
    });
       // add lazy load
            // var images = document.querySelectorAll('img');
            // images.forEach(function(image) {
            //     image.loading = 'lazy';
            // });
   // add width and height
    var images_width = document.querySelectorAll('img:not([width]):not([height])');
       images_width.forEach(function(image) {
                var img = new Image();
                img.onload = function() {
                    image.width = this.width;
                    image.height = this.height;
                };
                img.src = image.src;
            });    
 setTimeout(function(){ 
    $('.product-facet__filter-item .collapsible__content').each(function () {
      if($(this).children().length == 0){
        $(this).parents('.product-facet__filter-item').hide();
      }
    });
      }, 500); 
});
function freeShippingMsg(){
  var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};
  fetch('/cart.js')
    .then((resp) => resp.json())
    .then((cart) => {
    if(cart.total_price > 0){
      // console.log(cart.total_price);
      $('#valFreeShip').removeClass('hidden');
      var priceCart = cart.total_price;
      $('.shipping_box_wrp').removeClass('hidden');
      $('progress').attr('value',priceCart);
      // console.log(priceCart);
      var minOrderValue = $('#valFreeShip').attr('data-freeshipment');
      // console.log(minOrderValue);
        if (priceCart >= minOrderValue){
          $('#valFreeShip').html("<div class='free_ship_msg'>You have unlocked free shipping on AeroPress branded products!</div>");
          $('.shipping_box_wrp').addClass('reached_value');
          $('.cart-drawer__footer').css('visibility', 'visible');
          $('.drawer.drawer-items .subtext').css('visibility', 'visible');
          $('.tab-checkout').show();
          // $('.drawer__footer .cart__ctas').show();
            // console.log('here1')
        }else{
          let percent = priceCart / minOrderValue * 100;
          let left = Shopify.formatMoney(minOrderValue - priceCart);
          $('#valFreeShip').html("<div class='free_ship_msg'>Add<span> "+ left +"</span> to unlock free shipping on AeroPress branded products!</div>");
          $('.shipping_box_wrp').removeClass('reached_value');
          $('.cart-drawer__footer').css('visibility', 'hidden');
          $('.drawer.drawer-items .subtext').css('visibility', 'hidden');
          $('.tab-checkout').hide();
          // $('.drawer__footer .cart__ctas').hide();
          // console.log('here')
        }
    }else{
      // console.log('not total')
      $('#valFreeShip').addClass('hidden');
      $('.shipping_box_wrp').addClass('hidden');
    }
  });
}
$(document).on('click', '.mini-cart .quantity-selector__button,.mini-cart .line-item__remove-button,.product-form__add-button,.product-item__quick-form .button,button#AddToCart', function(){
    // console.log('checkout')
    setTimeout(function() {
      freeShippingMsg();
    },2000);
  });

$(document).ready(function () {
  const qtyIncrease = $('.quantity-selector__button.qty-increase');
  const qtyDecrease = $('.quantity-selector__button.qty-decrease');
  const quantityInput = $('.quantity-selector__input');
  const hiddenQty = $(".form-hidden-qty-num");

  // Increase quantity
  qtyIncrease.on('click', function () {
    let currentValue = parseInt(quantityInput.val()) || 1;
    hiddenQty.val(currentValue + 1);
  });

  // Decrease quantity
  qtyDecrease.on('click', function () {
    let currentValue = parseInt(quantityInput.val()) || 1;
    if (currentValue > 1) {
      hiddenQty.val(currentValue - 1);
    }
  });
});

//New Custom
document.addEventListener("DOMContentLoaded", function() {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }

  const swatches = document.querySelectorAll(".pcf--swatch");
  swatches.forEach((swatch) => {
    swatch.addEventListener("mouseover", function () {
      const variantImg = this.getAttribute("data-variant-image");
      const variantId = this.getAttribute("data-variant-id");
      const productBlock = this.closest('.ftrp--product-block');
      const productImg = productBlock.querySelector('.ftrp--product-image');
      const variantInput = productBlock.querySelector('[name="id"]');

      productImg.src = variantImg;
      variantInput.value = variantId;
      $('.pcf--swatch').removeClass('color-active');
      this.classList.add('color-active');
    });
  });

  $('#videoSteps .slick-carousel-container').on('afterChange', function(event, slick, currentSlide){
    if(currentSlide == 0) {
      $('#videoSteps .slick-prev').css('opacity', 0.4);
      $('#videoSteps .slick-next').css('opacity', 1);
    }
    else if(currentSlide == 2) {
      $('#videoSteps .slick-prev').css('opacity', 1);
      $('#videoSteps .slick-next').css('opacity', 0.4);
    }
    else {
      $('#videoSteps .slick-prev').css('opacity', 1);
      $('#videoSteps .slick-next').css('opacity', 1);
    }
  });

  const hoverTarget = document.querySelector('.header__icon-learnmore');
  const toggleElement = document.querySelector('.menu-learn-more');

  hoverTarget.addEventListener('mouseenter', () => {
    toggleElement.hidden = !toggleElement.hidden;
  });

  toggleElement.addEventListener('mouseleave', () => {
    toggleElement.hidden = !toggleElement.hidden;
  });

  $('.header__secondary--carousel').slick({
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2.75,
    slidesToScroll: 2,
    autoplay: false,
    autoplaySpeed: 3000,
    arrows: true,
    prevArrow: $('.slide-prev'),
    nextArrow: $('.slide-next')
  });

  const mobileMenuToggle = document.querySelector('.header__icon-list .icon-burger-mobile button[is=toggle-button]');
  const mainHeader = document.querySelector('.header');

  mobileMenuToggle.addEventListener('click', function() {
    if(mobileMenuToggle.getAttribute('aria-expanded') == 'true') {
      mainHeader.classList.add('mobile-menu-opened');
    }
    else {
      mainHeader.classList.remove('mobile-menu-opened');
    }
  });

  const stampedBadge = document.querySelector('.pffr--wrapper .stamped-product-reviews-badge');
  if (stampedBadge) {
    stampedBadge.addEventListener('click', (e) => {
      e.stopPropagation();
      stampedBadge.closest('button.collapsible-toggle').click();
    });
  }

});